var React = require('react');

function Time (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"d":"M12.2734 12.2728L17.3864 17.3868M12.2734 23.7268C18.5994 23.7268 23.7274 18.5988 23.7274 12.2728C23.7274 5.94682 18.6004 0.817818 12.2734 0.817818C5.94736 0.817818 0.818359 5.94682 0.818359 12.2728C0.818359 18.5988 5.94736 23.7268 12.2734 23.7268ZM12.2734 12.2728V8.18182V12.2728Z","stroke":"#461541","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"25","height":"25","fill":"white","transform":"translate(0 -0.000183105)"})))]);
}

Time.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = Time;

Time.default = Time;
